import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React, { CSSProperties, PropsWithChildren } from "react";

type SectionLoaderProps = PropsWithChildren & {
  isLoading?: boolean;
  containerStyle?: CSSProperties;
};

export const SectionLoader = (props: SectionLoaderProps) => {
  const { isLoading, containerStyle, children } = props;

  if (!isLoading) return <>{children}</>;

  const style: CSSProperties = {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    ...containerStyle,
  };

  return (
    <div style={style}>
      <Spin indicator={<LoadingOutlined spin />} />
    </div>
  );
};
